import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export type TimeBasedGreetingReturn = {
  greeting: string;
  bgImg: string;
  retestBgImg: string;
};

export const getTimeBasedGreetingAndBgImg = (): TimeBasedGreetingReturn => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const localHour = dayjs().tz(userTimezone).hour();
  const localMinute = dayjs().tz(userTimezone).minute();

  const currentTime = localHour + localMinute / 60;

  if (currentTime >= 0 && currentTime < 12) {
    return {
      greeting: 'Good morning',
      bgImg:
        'https://res.cloudinary.com/dsf1qebes/image/upload/v1741384993/Hero_Background_kvlhev.jpg',
      retestBgImg:
        'https://res.cloudinary.com/dttltpafi/image/upload/v1741259364/Hero_Background_1_ccecxj.jpg',
    };
  } else if (currentTime >= 12 && currentTime < 17) {
    return {
      greeting: 'Good afternoon',
      bgImg:
        'https://res.cloudinary.com/dttltpafi/image/upload/v1741089777/Hero_Background_vh5ptg.jpg',
      retestBgImg:
        'https://res.cloudinary.com/dttltpafi/image/upload/v1741259365/Hero_Background_2_tp1yer.jpg',
    };
  } else {
    return {
      greeting: 'Good evening',
      bgImg:
        'https://res.cloudinary.com/dttltpafi/image/upload/v1741331566/Hero_Background-2_j1ezuw.jpg',
      retestBgImg:
        'https://res.cloudinary.com/dttltpafi/image/upload/v1741259367/Hero_Background_3_wvootr.jpg',
    };
  }
};

export const isRecentlyPublished = (dateString?: string): boolean => {
  if (!dateString) {
    return false;
  }
  // Parse the input date string
  const givenDate = new Date(dateString);
  const currentDate = new Date();

  // Calculate the difference in milliseconds
  const differenceInMs = currentDate.getTime() - givenDate.getTime();

  // Convert milliseconds to days
  const differenceInDays = differenceInMs / (1000 * 60 * 60 * 24);

  // Check if difference is between 0 and 7 days
  return differenceInDays >= 0 && differenceInDays <= 7;
};
